import React, { Fragment } from 'react';
import { Provider } from 'react-redux';
import Helmet from 'react-helmet';
import { Script as FBSDKScript } from '@tusken-s/facebook-tools';
import configureStore from '../stores/configureStore';
import Favicon from '../assets/images/favicon.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/style.css';
import SideShortcut from '../components/SideShortcut';

const store = configureStore();

export default function Root({ children, data }) {
  return (
    <Provider store={store}>
      <Layout children={children} data={data} />
    </Provider>
  );
}

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;

class Layout extends React.Component {
  componentDidMount() {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: `291848856866405`,
        autoLogAppEvents: true,
        status: true,
        cookie: true,
        xfbml: true,
        version: 'v16.0',
      });
      FB.AppEvents.logPageView();
    };
    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      // @ts-ignore
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      // @ts-ignore
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  getYear = () => {
    return new Date().getFullYear();
  };

  render() {
    const { children, data } = this.props;
    return (
      <Fragment>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'We know how to party, GAS est une société qui possède plusieurs restaurants, bars, hôtels, cafés, boites de nuit, et centres d’animation et de loisirs dans Sousse et Hammamet.',
            },
            {
              name: 'keywords',
              content:
                "boite de nuit, club, tunisie, tunisia, disco, bar, hotels, restaurant, kantaoui, dance, beer, golfbrau, sousse, hammamet, leqg, treesome, l'artisto, ecovillage, fairground",
            },
            {
              name: 'author',
              content: `Tuskens ${this.getYear()}`,
            },
          ]}
        >
          <link rel="icon" type="image/png" href={Favicon} />
          <link href="https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700" rel="stylesheet" />
          <link
            rel="stylesheet"
            href="https://use.fontawesome.com/releases/v5.1.1/css/all.css"
            integrity="sha384-O8whS3fhG2OnA5Kas0Y9l3cfpmYjapjI0E4theH4iuMD+pLhbf6JI0jIMfYcK3yZ"
            crossOrigin="anonymous"
          />
          <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />
        </Helmet>
        <FBSDKScript cookie={false} nonce="yeIxR2ai" features={['loginButton']} appId="291848856866405" />
        <div className="app-container container-fluid">{children()}</div>
        <SideShortcut />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js